import type { MessageDescriptor } from 'react-intl';
import { DIRECTED_CAST_ROLES, type DirectedCastRole } from 'fym-shared/src/music24/directedVideoApi';
import { castMessages } from '../messages/castMessages';

/** The name of each cast role, in the order of the role buttons (design b1). */
export const CAST_ROLE_MESSAGES: Readonly<Record<DirectedCastRole, MessageDescriptor>> = {
  person: castMessages.rolePerson,
  place: castMessages.rolePlace,
  object: castMessages.roleObject,
  style: castMessages.roleStyle,
};

export const CAST_ROLES: readonly DirectedCastRole[] = DIRECTED_CAST_ROLES;
